/**
 * <toast-notifications> — transient cart confirmations.
 * Rebuilt from live's ToastNotifications (assets/custom.js build).
 *
 * Listens for the document event `toast:trigger` with
 * detail { duration, text, type } (types in use: 'info', 'error').
 *
 * Live behaviour kept: the host's data-toast-duration attribute wins over the
 * event's duration when present (on live the attribute always exists, so every
 * toast lasts exactly its value); text is set via innerText (HTML-safe);
 * newest toast prepends; auto-dismiss only (no close button); dismissal sets
 * inline opacity/transform and removes the node after the 1s fade.
 */
if (!customElements.get('toast-notifications')) {
  class ToastNotifications extends HTMLElement {
    connectedCallback() {
      this.container = this.querySelector('.toast-notification-container');
      this.duration = this.dataset.toastDuration;
      this.triggerListener = this.onTrigger.bind(this);
      document.addEventListener('toast:trigger', this.triggerListener);
    }

    disconnectedCallback() {
      document.removeEventListener('toast:trigger', this.triggerListener);
    }

    onTrigger(event) {
      const settings = event.detail || {};
      const duration = this.duration != null ? this.duration : settings.duration != null ? settings.duration : 3000;
      const text = settings.text != null ? settings.text : '';
      const type = settings.type != null ? settings.type : 'info';
      this.showNotification(text, type, duration);
    }

    showNotification(text, type, duration) {
      if (!this.container) return;
      const notification = document.createElement('div');
      notification.classList.add('toast-notification', 'font__body-extra-small', `type-${type}`);
      notification.innerText = text;

      this.container.prepend(notification);

      setTimeout(() => this.closeNotification(notification), duration);
    }

    closeNotification(notification) {
      notification.style.opacity = '0';
      notification.style.transform = 'translateY(-100%)';
      setTimeout(() => {
        if (notification.parentElement) this.container.removeChild(notification);
      }, 1000);
    }
  }

  customElements.define('toast-notifications', ToastNotifications);
}
